module.exports = __webpack_public_path__ + "media/images/icons/outlined/vertical-align-middle-06621fb24e42ce3f632f842287771db5.svg";